/**
 *  Scroll next
 *
 */

import globals from '../settings/globals';
import $ from 'jquery';
import utilities from '../utilities/utilities.js';

let scrollNext = {
  $action: $('[data-scroll-next]'),

  init: function () {
    this.$action.on('click', function (e) {
      e.preventDefault();

      let $current = $(e.currentTarget),
        $next = $current.closest('section').next();

      utilities.scrollAnimation($next.offset().top - globals.headerHeight - globals.wpAdminHeight);
    })
  }
};

scrollNext.init();

export default scrollNext;
